import type { ReactNode, Ref } from 'react';
import { Box, Paper } from '@mui/material';

export interface FilterBarProps {
  /** Filter controls (search, segmented controls, chips). */
  children?: ReactNode;
  /** Trailing actions, pushed to the right. */
  trailing?: ReactNode;
  ref?: Ref<HTMLDivElement>;
}

/**
 * Toolbar that sits under a {@link PageHeader}: a horizontal, wrapping row of
 * filter controls with an optional right-aligned trailing slot.
 */
export function FilterBar({ children, trailing, ref }: FilterBarProps) {
  return (
    <Paper
      ref={ref}
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        p: '12px 18px',
        borderRadius: '4px',
      }}
    >
      {children}
      {trailing && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, ml: 'auto' }}>{trailing}</Box>
      )}
    </Paper>
  );
}
